// extracted by mini-css-extract-plugin
export default {"tabContainer":"financialStatement_tabContainer__o0Lw1","tabs":"financialStatement_tabs__Hv6PK","tabItem":"financialStatement_tabItem__PJTmR"};